import { DailyPrize } from "./types";

export const FINAL_PRIZES: DailyPrize[] = [
  {
    count: "1",
    imgId: "yaris",
    // imgId: "1-bmw-m4",
    prize: "Toyota GR Yaris or £21k cash",
    // prize: "BMW M4 or £32K Cash",
  },
  {
    prize: "£2,000 Cash",
    count: "5",
    imgId: "2000-cash",
  },
  {
    prize: "£500 Cash",
    count: "20",
    imgId: "500-cash",
  },
  {
    prize: "£100 Cash",
    count: "50",
    imgId: "100-cash",
  },
  {
    prize: "£50 Cash",
    count: "100",
    imgId: "50-cash",
  },
  {
    prize: "£25 Cash",
    count: "200",
    imgId: "25-cash",
  },
  {
    prize: "Keyboxes",
    count: "2,000",
    imgId: "keyboxes",
  },
  {
    prize: "£10 Game Credit",
    count: "500",
    imgId: "10-game-credit",
  },
  {
    prize: "£5 Game Credit",
    count: "824",
    imgId: "5-game-credit",
  },
  {
    prize: "15 Dream Home Tickets",
    count: "300",
    imgId: "dream-home",
  },
  {
    prize: "5 Dream Home Tickets",
    count: "3,000",
    imgId: "dream-home",
  },
  {
    prize: "1 Dream Home Tickets",
    count: "5,000",
    imgId: "dream-home",
  },
];
